import { limitsRef } from "../../../../constants/helpful-link";
import { PromoMechanic } from "../../../../types/componentTypes/editPromotion";
import { AGE_LIMIT_LAMBDA, IW_PRIZE_LIMITS_LAMBDA, PARTICIPATION_LIMIT_LAMBDA } from "../../../../types/componentTypes/limits";

export const helpfulLinks = {
  [PromoMechanic.InstantWin]: [
    {
      link: limitsRef.LIMITS,
      text: 'Limits',
    },
    {
      link: limitsRef.PARTICIPATION_LIMITS,
      text: 'Participation Limits',
    },
    {
      link: limitsRef.WINNING_LIMITS,
      text: 'Winning Limits',
    },
  ],
  [PromoMechanic.PromoEntry]: [
    {
      link: limitsRef.LIMITS,
      text: 'Limits',
    },
    {
      link: limitsRef.PARTICIPATION_LIMITS,
      text: 'Participation Limits',
    },
  ],
  [PromoMechanic.CollectAndGet]: [
    {
      link: limitsRef.LIMITS,
      text: 'Limits',
    },
    {
      link: limitsRef.PARTICIPATION_LIMITS,
      text: 'Participation Limits',
    },
    {
      link: limitsRef.REDEMPTION_LIMITS,
      text: 'Redemption Limits',
    },
  ],
  [PromoMechanic.AutoRedeemCnG]: [
    {
      link: limitsRef.LIMITS,
      text: 'Limits',
    },
    {
      link: limitsRef.PARTICIPATION_LIMITS,
      text: 'Participation Limits',
    },
    {
      link: limitsRef.REDEMPTION_LIMITS,
      text: 'Redemption Limits',
    },
],
[PromoMechanic.LuckyNumbers]: [
   {
      link: limitsRef.LIMITS,
      text: 'Limits',
    },
    {
      link: limitsRef.PARTICIPATION_LIMITS,
      text: 'Participation Limits',
    },
],
};

export const limitChekerLambdas = [
    AGE_LIMIT_LAMBDA,
    IW_PRIZE_LIMITS_LAMBDA,
    PARTICIPATION_LIMIT_LAMBDA,
];
